// extracted by mini-css-extract-plugin
export default {"title":"Members_title__SCICR","wrapper":"Members_wrapper__8PrNt","header":"Members_header__cwkqb","copyLink":"Members_copyLink__VPv1S"};